import { ONB_PARTNER_DATA_FORM_TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/translations'
import { memo, useCallback } from 'react'

import { getLabelByExternalField } from 'clickNgo/entities/partner/libs/helpers'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { IHorizontalMenuLabelWithInfoProps } from './models'

import styles from './HorizontalMenuLabelWithInfo.module.scss'

export const HorizontalMenuLabelWithInfo = memo<IHorizontalMenuLabelWithInfoProps>(
  ({ isInactive, title, status, modifiedValues = [] }) => {
    const tooltipContent = useCallback(
      () => (
        <>
          <div style={{ display: 'flex' }}>{status}:</div>{' '}
          <ul
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              alignItems: 'flex-start',
              paddingTop: 4,
            }}
          >
            {modifiedValues?.map(getLabelByExternalField).map((label) => (
              <li key={label}>
                <Translation text={label as string} span />
              </li>
            ))}
          </ul>
        </>
      ),
      [modifiedValues, status]
    )

    if (status && !isInactive) {
      return (
        <div className={styles.container}>
          <Translation text={title} />
          <Tooltip tipContent={tooltipContent}>
            <span className={styles.status}>
              <Translation text={ONB_PARTNER_DATA_FORM_TRANSLATION_KEYS.other.menuStatus} />
              <span className={styles.statusText}>{status}</span>
            </span>
          </Tooltip>
        </div>
      )
    }

    return <Translation text={title} />
  }
)
